import { useEffect, useState } from 'react'
import { fetchReservationDetailSalesMasters } from '@/apis/aipass'
import { ReservationDetailSalesMastersType } from '@/models/sales-manager/sales'
import { useErrorHandler } from '@/hooks/use-error-handler'

const emptyMasters: ReservationDetailSalesMastersType = {
  salesSubjects: [],
  salesPayments: [],
  salesDiscounts: [],
  accountsReceivables: [],
  advanceCompany: { paymentCompanies: [], paymentMethod: [] },
  salesSubjectSets: [],
  salesSubjectTaxes: [],
}

/**
 * 予約詳細画面の売上ブロックで使うマスタ・設定を取得する。
 * 売上ブロックの親と子（利用明細・入金フォーム）が 7 本の API を別々に呼んでいたため、1 リクエストにまとめて親で 1 回だけ取得する。
 */
export const useReservationDetailSalesMasters = () => {
  const { errorHandler } = useErrorHandler()
  const [masters, setMasters] = useState<ReservationDetailSalesMastersType>(emptyMasters)
  // 入金フォームは取得完了後に支払方法の選択肢を組み立てるため、取得済みかを別に持つ
  const [isMastersLoaded, setIsMastersLoaded] = useState<boolean>(false)

  // マスタは設定画面でしか変わらないため、画面を開いたときに 1 回だけ取得する（個別に取得していたときと同じ頻度）
  useEffect(() => {
    fetchReservationDetailSalesMasters()
      .then(res => {
        setMasters(res)
        setIsMastersLoaded(true)
      })
      .catch(error => {
        // 売上ブロックは売上画面の権限を見ずに表示されるため、権限が無いスタッフには通知せず空のまま表示する（個別に取得していたときと同じ見え方）
        if (error?.response?.status === 403) return
        errorHandler(error)
      })
  }, [])

  return { masters, isMastersLoaded }
}
